import {
  // Backdrop,
  Box,
  Button,
  // Chip,
  CircularProgress,
  Divider,
  FormControl,
  FormLabel,
  InputAdornment,
  Popover,
  // MenuItem,
  // Select,
  TextField,
  // Typography,
} from "@mui/material";
import React, { useState } from "react";
import { HexColorPicker } from "react-colorful";
import { ColorBox } from "../../../Common/UI/ColourPicker";
import {
  CommonDrawerStyle,
  DrawerForm,
  DrawerHeader,
} from "../../../Common/styles/drawer";
import { Formik, Form } from "formik";
import { useParams } from "react-router-dom";
import { InputWrapper, LabelStyle } from "../../../Common/styles/form";
import { ModalActionButtonStyles } from "../../../Common/styles/modal";
import * as yup from "yup";
// import { useAppSelector } from "../../../../Redux/hooks";
import { AxiosResponse } from "axios";
import http from "../../../../utils/http";
import { errorToastMessage, toastMessage } from "../../../../utils/toast";
// import { CloseRounded } from "@mui/icons-material";
// import Loader from "../../../Common/assets/Loader";

type Props = {
  closeDrawer: () => void;
  data?: any;
  refreshPage: () => void;
};

const schema = yup.object().shape({
  name: yup.string().trim().required("User Group Name is Required"),
  targetParticipantCount: yup
    .number()
    .min(1, "Target participant count must be greater than 0")
    .required("Target participant count is Required"),
  color: yup.string().trim().required("Group Color is Required"),
  code: yup.string().trim().required("Code is Required"),
  // siteId: yup.string().required("Site is Required"),
  // participants: yup
  //   .array()
  //   .of(yup.string().required("Participant is Required")),
});

const AddGroupDrawer: React.FC<Props> = ({
  closeDrawer,
  data,
  refreshPage,
}) => {
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const [colorPickerAnchor, setColorPickerAnchor] =
    useState<HTMLElement | null>(null);
  // const [participantsList, setParticipantsList] = useState<any>([]);
  // const [initialList, setInitialList] = useState<any[]>([]);
  // const sitesList = useAppSelector((state) => state.study.sitesList);
  // const [siteId, setSiteId] = useState<string>("");
  // const [loading, setLoading] = useState<boolean>(false);
  const { id } = useParams();

  const handleColorPickerOpen = (event: React.MouseEvent<HTMLElement>) => {
    setColorPickerAnchor(event.currentTarget);
  };

  const handleColorPickerClose = () => {
    setColorPickerAnchor(null);
  };

  // useEffect(() => {
  //   async function getGroupData() {
  //     try {
  //       setLoading(true);
  //       const res: AxiosResponse = await http.get(
  //         `/study/${id}/participant-groups/${data?.id}`
  //       );
  //       const groupData = res.data.data;
  //       const participants = groupData?.participantGroupMembers?.map(
  //         (participant: any) => {
  //           return {
  //             id: participant?.participant?.id,
  //             subjectId: participant?.participant?.subjectId,
  //           };
  //         }
  //       );
  //       setInitialList(participants);
  //     } catch (err) {
  //       errorToastMessage(err as Error);
  //       console.error(err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  //   if (data?.id) {
  //     getGroupData();
  //   }
  // }, [data?.id, id]);

  // useEffect(() => {
  //   async function getParticipants() {
  //     try {
  //       setLoading(true);
  //       let url: string = `participants/minimal?studyId=${id}`;
  //       if (!data?.id) {
  //         url += `&isLocked=false&isArchived=false&eligibilityStatus=unverified,included`;
  //       }

  //       const res: AxiosResponse = await http.get(url);

  //       const participants = res.data.data;
  //       const newData = participants?.map((participant: any) => {
  //         return {
  //           id: participant?.id,
  //           subjectId: participant?.subjectId,
  //           isDisabled:
  //             participant?.isLocked ||
  //             participant?.isArchived ||
  //             participant?.eligibilityStatus === "excluded",
  //           isLocked: participant?.isLocked,
  //           isArchived: participant?.isArchived,
  //           isExcluded: participant?.eligibilityStatus === "excluded",
  //         };
  //       });

  //       setParticipantsList(newData);
  //     } catch (err) {
  //       errorToastMessage(err as Error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  //   getParticipants();
  // }, [data?.id, id]);

  async function submitHandler(values: any) {
    try {
      setSubmitLoader(true);
      let url: string = ``;
      let res: AxiosResponse;
      let obj: any;
      if (data?.id) {
        obj = {
          // siteId: values?.siteId || "",
          name: values.name || "",
          targetCount: values.targetParticipantCount,
          colorCode: values.color,
          code: values.code,
          // removeIds:
          //   initialList
          //     ?.filter(
          //       (participant: any) =>
          //         !values?.participants.includes(participant?.id)
          //     )
          //     ?.map((participant: any) => participant?.id) || [],
          // addIds: values?.participants.filter(
          //   (id: string) => !initialList.some((item: any) => item?.id === id)
          // ),
        };
        url = `/study/${id}/participant-groups/${data?.id}`;
        res = await http.patch(url, obj);
      } else {
        obj = {
          name: values?.name || "",
          targetCount: values?.targetParticipantCount,
          colorCode: values?.color,
          code: values?.code,
          // siteId: values?.siteId || "",
          // siteName: sitesList.find((site: any) => site.id === values?.siteId)
          //   .name,
          // participants: values?.participants,
        };
        url = `/study/${id}/participant-groups`;
        res = await http.post(url, obj);
      }
      toastMessage("success", res.data.message);
      closeDrawer();
      refreshPage();
    } catch (err) {
      errorToastMessage(err as Error);
    } finally {
      setSubmitLoader(false);
    }
  }
  return (
    <Box sx={CommonDrawerStyle}>
      <DrawerHeader
        closeDrawer={closeDrawer}
        title={`${data?.id ? "Edit" : "Add"} User Group`}
      />
      <Formik
        initialValues={{
          name: data?.groupName || "",
          targetParticipantCount: data?.targetParticipantCount ?? 1,
          color: data?.color || "",
          code: data?.code || "",
          // siteId: data?.site || "",
          // participants:
          //   initialList?.length > 0 ? initialList?.map((p) => p?.id) : [],
          // displayParticipants: initialList?.length > 0 ? initialList : [],
        }}
        enableReinitialize
        onSubmit={(values: any) => {
          submitHandler(values);
        }}
        validationSchema={schema}
      >
        {({ getFieldProps, errors, touched, values, setFieldValue }) => (
          <Form style={DrawerForm}>
            <Box>
              <FormControl sx={InputWrapper}>
                <FormLabel sx={LabelStyle} htmlFor="group-name">
                  User Group Name <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <TextField
                  placeholder="Name"
                  id="group-name"
                  {...getFieldProps("name")}
                  error={touched?.name && errors?.name ? true : false}
                  helperText={
                    touched?.name && errors?.name
                      ? (errors?.name as string)
                      : " "
                  }
                />
              </FormControl>
              <Box sx={{ display: "flex", gap: 2 }}>
                <FormControl sx={InputWrapper}>
                  <FormLabel sx={LabelStyle} htmlFor="code">
                    Code <span style={{ color: "red" }}>*</span>
                  </FormLabel>
                  <TextField
                    placeholder="Abbreviation"
                    id="code"
                    {...getFieldProps("code")}
                    error={touched?.code && errors?.code ? true : false}
                    helperText={
                      touched?.code && errors?.code
                        ? (errors?.code as string)
                        : " "
                    }
                  />
                </FormControl>
                <FormControl sx={InputWrapper}>
                  <FormLabel sx={LabelStyle} htmlFor="target-participant-count">
                    Target Participant Count{" "}
                    <span style={{ color: "red" }}>*</span>
                  </FormLabel>
                  <TextField
                    type="number"
                    placeholder="Enter target count"
                    id="target-participant-count"
                    {...getFieldProps("targetParticipantCount")}
                    error={
                      touched?.targetParticipantCount &&
                      errors?.targetParticipantCount
                        ? true
                        : false
                    }
                    helperText={
                      touched?.targetParticipantCount &&
                      errors?.targetParticipantCount
                        ? (errors?.targetParticipantCount as string)
                        : " "
                    }
                  />
                </FormControl>
              </Box>
              <FormControl sx={InputWrapper}>
                <FormLabel sx={LabelStyle} htmlFor="color">
                  Group Color <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 2,
                  }}
                >
                  <ColorBox
                    onClick={handleColorPickerOpen}
                    sx={{
                      backgroundColor: values.color || "#E5E7EB",
                      border: "1px solid",
                      borderColor: "divider",
                      cursor: "pointer",
                      width: "46px",
                      height: "46px",
                    }}
                  />
                  <TextField
                    placeholder="7E3AF2"
                    id="color"
                    value={values.color ? values.color.replace("#", "") : ""}
                    onChange={(e) => {
                      const hexValue = e.target.value.replace("#", "");
                      if (/^[0-9A-Fa-f]{0,6}$/.test(hexValue)) {
                        setFieldValue("color", hexValue ? `#${hexValue}` : "");
                      }
                    }}
                    error={touched?.color && errors?.color ? true : false}
                    helperText={
                      touched?.color && errors?.color
                        ? (errors?.color as string)
                        : " "
                    }
                    sx={{ flex: 1 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">#</InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <Popover
                  open={Boolean(colorPickerAnchor)}
                  anchorEl={colorPickerAnchor}
                  onClose={handleColorPickerClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      "& .react-colorful__hue": {
                        height: "12px",
                        mt: 2,
                        mb: 2,
                        borderRadius: 1,
                      },
                      "& .react-colorful__saturation": {
                        borderRadius: 0.5,
                        height: "152px",
                      },
                      "& .react-colorful__pointer": {
                        height: "12px",
                        width: "12px",
                        borderWidth: 3,
                      },
                    }}
                  >
                    <HexColorPicker
                      color={values.color || "#7E3AF2"}
                      onChange={(color) => {
                        setFieldValue("color", color);
                      }}
                    />
                  </Box>
                </Popover>
              </FormControl>
              {/* <FormControl sx={InputWrapper}>
                <FormLabel sx={LabelStyle} htmlFor="site">
                  Site <span style={{ color: "red" }}>*</span>
                </FormLabel>
                <Select
                  value={values?.siteId}
                  renderValue={() =>
                    sitesList?.find((site: any) => site?.id === values?.siteId)
                      ?.name || (
                      <Typography color="gray">Select Site</Typography>
                    )
                  }
                  readOnly={data?.id ? true : false}
                  placeholder="Select Site"
                  displayEmpty
                  onChange={(e) => {
                    setFieldValue(`siteId`, e.target.value);
                    setSiteId(e.target.value);
                    setFieldValue("participants", []);
                    setFieldValue("displayParticipants", []);
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: { maxHeight: "300px", overflowY: "auto" },
                    },
                  }}
                  error={touched?.siteId && errors?.siteId ? true : false}
                >
                  {sitesList?.map((site) => (
                    <MenuItem key={site.id} value={site.id}>
                      {site.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  error={touched?.siteId && errors?.siteId ? true : false}
                >
                  {touched?.siteId && errors?.siteId
                    ? (errors?.siteId as string)
                    : " "}
                </FormHelperText>
              </FormControl> */}
              {/* <FormControl sx={InputWrapper}>
                <FormLabel sx={LabelStyle} htmlFor="participants">
                  Participants
                </FormLabel>
                <Select
                  value={
                    values?.participants?.length > 0
                      ? values?.participants?.map((p: any) => p)
                      : []
                  }
                  multiple
                  MenuProps={{
                    PaperProps: {
                      style: { maxHeight: "280px", overflowY: "auto" },
                    },
                  }}
                  displayEmpty
                  onChange={(e) => {
                    const selectedValues = e.target.value;
                    setFieldValue(`participants`, selectedValues);
                    const selectedParticipants = participantsList?.filter(
                      (participant: any) =>
                        selectedValues.includes(participant.id)
                    );
                    setFieldValue(`displayParticipants`, selectedParticipants);
                  }}
                  renderValue={() => (
                    <Box
                      sx={{ display: "flex", gap: 0.5, alignItems: "center" }}
                    >
                      {values?.participants?.length > 0 ? (
                        <Typography>
                          {values.participants?.length} Selected
                        </Typography>
                      ) : (
                        <Typography sx={{ color: "gray" }}>
                          Select Participants
                        </Typography>
                      )}
                    </Box>
                  )}
                  error={
                    touched?.participants && errors?.participants ? true : false
                  }
                >
                  {participantsList?.length > 0 ? (
                    participantsList?.map((participant: any) => (
                      <MenuItem
                        key={participant?.id}
                        value={participant?.id}
                        disabled={participant?.isDisabled}
                      >
                        {participant?.subjectId}{" "}
                        {participant?.isLocked ? "(Locked)" : ""}{" "}
                        {participant?.isArchived ? "(Archived)" : ""}{" "}
                        {participant?.isExcluded ? "(Excluded)" : ""}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value="" disabled>
                      <em>No options available</em>
                    </MenuItem>
                  )}
                </Select>
                <FormHelperText
                  error={
                    touched?.participants && errors?.participants ? true : false
                  }
                >
                  {touched?.participants && errors?.participants
                    ? (errors?.participants as string)
                    : " "}
                </FormHelperText>
              </FormControl> */}
              {/* {values?.displayParticipants?.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    mr: 2,
                    mb: 3,
                    flexWrap: "wrap",
                  }}
                >
                  {values?.displayParticipants?.map((participant: any) => (
                    <Chip
                      sx={{
                        borderRadius: 1,
                        backgroundColor: "secondary.main",
                      }}
                      deleteIcon={
                        <CloseRounded
                          sx={{
                            color: "text.primary",
                            height: "16px",
                            width: "16px",
                          }}
                        />
                      }
                      key={participant?.id}
                      label={participant?.subjectId}
                      onDelete={() => {
                        const participants = values?.participants?.filter(
                          (p: any) => p !== participant?.id
                        );

                        const newDisplayParticipants =
                          values?.displayParticipants?.filter(
                            (p: any) => p?.id !== participant?.id
                          );

                        setFieldValue("participants", participants);
                        setFieldValue(
                          "displayParticipants",
                          newDisplayParticipants
                        );
                      }}
                    />
                  ))}
                </Box>
              )} */}
            </Box>
            <Box sx={{ mt: "auto" }}>
              <Divider />
              <Box sx={{ ...ModalActionButtonStyles, mt: 2, mb: 2 }}>
                {!submitLoader ? (
                  <>
                    <Button onClick={closeDrawer} variant="outlined">
                      Cancel
                    </Button>
                    <Button type="submit" variant="contained">
                      Submit
                    </Button>
                  </>
                ) : (
                  <CircularProgress size={25} />
                )}
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
      {/* {loading && (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      )} */}
    </Box>
  );
};

export default AddGroupDrawer;
